// TODO get these urls from .env
export const REACT_APP_API_USER_URL = '/user/graphql';
export const REACT_APP_API_CATALOG_URL = '/catalog/graphql';
export const URL_3D = '/catalog/api/complete3D';
